var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCockpitSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CockpitIconSmall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CockpitIconSmall",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6875,36 L7.3125,36 C3.273975,36 0,32.726025 0,28.6875 L0,7.3125 C0,3.273975 3.273975,0 7.3125,0 L28.6875,0 C32.726025,0 36,3.273975 36,7.3125 L36,28.6875 C36,32.726025 32.726025,36 28.6875,36",
    id: "Fill-1",
    fill: "#00C792"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(4.419751, 5.531130)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1134203,3.96039375 C17.8328953,-1.32013125 9.24093281,-1.32013125 3.96029531,3.96039375 C-1.32011719,9.24091875 -1.32011719,17.8329937 3.96040781,23.1134063 C4.35584531,23.5088438 4.87402031,23.7066188 5.39230781,23.7066188 C5.91048281,23.7066188 6.42865781,23.5088438 6.82409531,23.1134063 C7.61497031,22.3226438 7.61497031,21.0404813 6.82409531,20.2497188 C3.12284531,16.5483563 3.12284531,10.5255563 6.82409531,6.82419375 C9.64987031,3.99853125 13.8274453,3.33264375 17.2933453,4.82113125 L17.6010328,4.51344375 C18.1534078,3.96106875 18.8879203,3.65675625 19.6692328,3.65675625 C20.4504328,3.65675625 21.1849453,3.96106875 21.7374328,4.51344375 C22.2900328,5.06581875 22.5942328,5.80033125 22.5942328,6.58175625 C22.5942328,7.36306875 22.2900328,8.09758125 21.7374328,8.65006875 L21.7012078,8.68618125 C22.5674578,10.1383312 23.0302828,11.8019813 23.0302828,13.5369563 C23.0302828,16.0727062 22.0427578,18.4565812 20.2497328,20.2496062 C19.4589703,21.0404813 19.4588578,22.3226438 20.2496203,23.1134063 C21.0406078,23.9043938 22.3228828,23.9042813 23.1134203,23.1135188 C25.6714453,20.5554938 27.0802828,17.1545063 27.0802828,13.5369563 C27.0802828,9.91940625 25.6714453,6.51830625 23.1134203,3.96039375",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1010541,5.14989 C20.7056166,4.7544525 20.1874416,4.55679 19.6691541,4.55679 C19.1509791,4.55679 18.6328041,4.7544525 18.2373666,5.14989 L18.1469166,5.24034 L12.1451541,11.2421025 C11.3541666,12.0329775 11.3541666,13.3150275 12.1451541,14.10579 C12.5404791,14.5012275 13.0587666,14.6990025 13.5769416,14.6990025 C14.0952291,14.6990025 14.6134041,14.5012275 15.0088416,14.10579 L21.1010541,8.0135775 C21.1323291,7.9823025 21.1602291,7.9490025 21.1891416,7.9161525 C21.8885541,7.1207775 21.8606541,5.9093775 21.1010541,5.14989",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCockpitSmall);
export default __webpack_public_path__ + "static/media/IconCockpitSmall.f7011bfc6e16df71f3c32f1454460c8e.svg";
export { ForwardRef as ReactComponent };